import { CSSProperties, useEffect, useRef } from "react"
import dynamic from "next/dynamic"

export type EmojiPickerProps = {
    onSelect: (emoji: string) => void
}

const EmojiPickerMount = ({ onSelect }: EmojiPickerProps) => {
    const ref = useRef(null)
    const instance = useRef<{ update: (props: object) => void } | null>(null)
    const onSelectRef = useRef(onSelect)
    onSelectRef.current = onSelect

    useEffect(() => {
        const props = {
            set: "native",
            theme: "dark",
            previewPosition: "none",
            searchPosition: "sticky",
            skinTonePosition: "none",
            onEmojiSelect: (emoji: { native: string }) => onSelectRef.current(emoji.native),
        }

        void Promise.all([import("emoji-mart"), import("@emoji-mart/data")]).then(
            ([{ Picker }, data]) => {
                instance.current = new Picker({
                    ...props,
                    data: "default" in data ? data.default : data,
                    ref,
                })
            }
        )

        return () => {
            instance.current = null
        }
    }, [])

    return (
        <div
            ref={ref}
            style={
                { "--rgb-background": "38, 40, 44", "--rgb-input": "56, 59, 64" } as CSSProperties
            }
        />
    )
}

export const EmojiPicker = dynamic(() => Promise.resolve(EmojiPickerMount), {
    ssr: false,
})
